import BronzeMedal from './assets/bronze-medal.svg';
import GoldMedal from './assets/gold-medal.svg';
import SilverMedal from './assets/silver-medal.svg';

export enum Position {
  Gold = 0,
  Silver = 1,
  Bronze = 2,
}

export enum PositionAnimationSequence {
  Enter = 0,
  Flip = 1,
  Translate = 2,
  Exit = 3,
}

export enum PositionAnimationSize {
  Medium = 0,
  Large = 1,
}

export enum PositionAnimationEnterAnimation {
  FadeIn = 0,
  SlideFromBack = 1,
}

export const ExitAnimationTime = {
  [Position.Gold]: 1500,
  [Position.Silver]: 500,
  [Position.Bronze]: 500,
};

export const ConfettiParticleCount = {
  [Position.Gold]: 90,
  [Position.Silver]: 60,
  [Position.Bronze]: 30,
};

export const ConfettiGravitiy = {
  [Position.Gold]: 2.75,
  [Position.Silver]: 3.75,
  [Position.Bronze]: 3.75,
};

export const MedalSource = {
  [Position.Gold]: GoldMedal,
  [Position.Silver]: SilverMedal,
  [Position.Bronze]: BronzeMedal,
};
